import { render, staticRenderFns } from "./OnboardingHsaFsaBadge.vue?vue&type=template&id=685aa20e&scoped=true"
import script from "./OnboardingHsaFsaBadge.vue?vue&type=script&lang=js"
export * from "./OnboardingHsaFsaBadge.vue?vue&type=script&lang=js"
import style0 from "./OnboardingHsaFsaBadge.vue?vue&type=style&index=0&id=685aa20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685aa20e",
  null
  
)

export default component.exports